
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowGuest?: boolean;
}

export default function ProtectedRoute({ children, allowGuest = true }: ProtectedRouteProps) {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);

  useEffect(() => {
    // Check if user is authenticated
    const userStr = localStorage.getItem('user');
    const guestMode = localStorage.getItem('guestMode');
    
    if (userStr) {
      const user = JSON.parse(userStr);
      // Check if email is verified
      if (user.emailVerified !== false) {
        setIsAuthenticated(true);
      } else {
        // Email not verified, redirect to login
        setIsAuthenticated(false);
        navigate('/auth/login');
        return;
      }
    } else if (allowGuest && guestMode) {
      setIsAuthenticated(true);
    } else if (allowGuest) {
      // Allow guest access - set as teacher for testing
      setIsAuthenticated(true);
      localStorage.setItem('guestMode', 'true');
      localStorage.setItem('user', JSON.stringify({
        name: "Teacher Demo",
        isTeacher: true,
        isParent: false,
        isStudent: false,
        role: "teacher",
        email: "teacher@demo.com",
        id: "teacher-demo-1",
        emailVerified: true
      }));
    } else {
      setIsAuthenticated(false);
      navigate('/auth/login');
    }
  }, [navigate, allowGuest]);

  // Show simple loading while checking
  if (isAuthenticated === null) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-green-50 to-emerald-50 flex items-center justify-center">
        <div className="text-center">
          <div className="w-8 h-8 bg-[#2d5a35] rounded-full animate-pulse mx-auto mb-2"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return null;
  }

  return <>{children}</>;
}
